module.exports = __webpack_public_path__ + "static/media/dennisRitchie.fb13fa81.jpg";